// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1Qw2R","ranges":"BmiRanges_ranges__1qZxD"};